// extracted by mini-css-extract-plugin
module.exports = {"si-wrapper":"NotificationBadge_si-wrapper__10GTP","silc-btn":"NotificationBadge_silc-btn__1yWUC","root":"NotificationBadge_root__1iaay"};